import EnterpriseFeatureLanding from '../../../shared/enterprise-upsell-page/enterprise-upsell-landing-page';
import GpanelApiVideoCardBackground from '../../../shared/enterprise-upsell-page/gpanel-api-video-card-background';

import PlayArrow from '@mui/icons-material/PlayArrow';
import SpaceDashboardOutlined from '@mui/icons-material/SpaceDashboardOutlined';

export default function ApiEnterpriseLanding() {
  return (
    <EnterpriseFeatureLanding
      title="gPanel API"
      description="Access the full power of gPanel with our comprehensive REST API.
            200+ endpoints to build custom integrations and automate your
            workflow."
      topButtons={[
        {
          label: 'App Management',
          icon: <SpaceDashboardOutlined />,
          variant: 'contained',
          mediaLink: 'https://play.hubspotvideo.com/v/22148155/id/224562181667',
        },
        {
          label: 'Creation Flow',
          icon: <PlayArrow />,
          variant: 'outlined',
          mediaLink: 'https://play.hubspotvideo.com/v/22148155/id/224562200599',
        },
      ]}
      featuresDescription={[
        '200+ RESTful API endpoints',
        'Complete API documentation',
      ]}
      learnMoreHref="https://gpanel.io/knowledge/automation/access-gpanel-api"
      videoCardBackground={<GpanelApiVideoCardBackground />}
    />
  );
}
